import { render, staticRenderFns } from "./About.vue?vue&type=template&id=8c9935ca&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=8c9935ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9935ca",
  null
  
)

export default component.exports